import { Component, Input } from '@angular/core';
import { ErrorService } from 'src/app/core/error.service';
import { Order, OrdersService } from 'src/app/core/orders.service';

@Component({
  selector: 'app-order-details-qinetic',
  templateUrl: './order-details-qinetic.component.html',
  styleUrls: ['./order-details-qinetic.component.scss'],
})
export class OrderDetailsQineticComponent {
  @Input() order_id?: string | null;
  @Input() store_id?: string | null;

  order?: Order;
  is_read_running = false;

  constructor(private orders_service: OrdersService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.readOrder(this.store_id as string, this.order_id as string);
  }

  onRefresh(): void {
    this.readOrder(this.store_id as string, this.order_id as string);
  }

  readOrder(store_id: string, order_id: string): void {
    this.is_read_running = true;
    this.orders_service.read(store_id, order_id).subscribe({
      next: response => {
        this.order = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }
}
